import * as React from 'react';

export const Plus = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="29"
		height="28"
		fill="none"
		viewBox="0 0 29 28"
		{...props}
	>
		<path
			fill="#008635"
			d="M13.625 19.25v-4.375H9.25A.864.864 0 0 1 8.375 14c0-.437.383-.875.875-.875h4.375V8.75c0-.437.383-.875.875-.875.438 0 .875.438.875.875v4.375h4.375c.438 0 .875.438.875.875 0 .492-.437.875-.875.875h-4.375v4.375c0 .492-.437.875-.875.875a.864.864 0 0 1-.875-.875M28.5 14c0 7.766-6.29 14-14 14-7.766 0-14-6.234-14-14 0-7.71 6.234-14 14-14 7.71 0 14 6.29 14 14m-14-12.25C7.719 1.75 2.25 7.273 2.25 14A12.23 12.23 0 0 0 14.5 26.25c6.727 0 12.25-5.469 12.25-12.25 0-6.727-5.523-12.25-12.25-12.25"
		></path>
	</svg>
);
